<template>
  <div class="col">
    <p>الغرض من سياسة الخصوصية هذه هو توفير المعلومات للمستخدم ("المستخدم") حول غرض معالجة البيانات الشخصية ونطاقها ومدتها والحقوق الشخصية عند استخدام موقع tobook.link وتطبيق الجوال ("tobook.link"، "التطبيق") وخدمات الحجز.</p>
    <p>نحن نهتم بحماية خصوصيتك وبياناتك الشخصية ولذلك نقوم بمعالجة بياناتك الشخصية وفقًا للقانون المطبق - اللائحة (EU) 2016/679 للبرلمان الأوروبي ومجلس الاتحاد الأوروبي بتاريخ 27 أبريل 2016 بشأن حماية الأشخاص الطبيعيين فيما يتعلق بمعالجة البيانات الشخصية وعلى الحركة الحرة لهذه البيانات، وإلغاء التوجيه 95/46/EC (اللائحة العامة لحماية البيانات) ("اللائحة")، فضلاً عن الأحكام القانونية الأخرى التي تنظم قضايا الخصوصية ومعالجة البيانات.</p>
    <p>يحتفظ tobook.link بالحق في مراجعة وتغيير هذه السياسة في أي وقت، وذلك بسبب التغييرات في الخدمات أو القوانين واللوائح المطبقة. سوف نخطرك بأي تغييرات كبيرة، ويجب عليك أن تكون مسؤولاً عن مراجعة هذه السياسة بانتظام.</p>
    <h6 class="mt-5 mb-3">
      المسؤول ومعلومات الاتصال به
    </h6>
    <p>المسؤول عن البيانات الشخصية هو tobook.link s.r.o. (رقم التسجيل 19608217)، العنوان القانوني: Pavla Beneše 750/8, Praha 19900. يمكنك الاتصال بنا في أي وقت لأي أسئلة أو طلبات متعلقة ببياناتك الشخصية.</p>
    <h6 class="mt-5 mb-3">
      فئات البيانات الشخصية
    </h6>
    <p>بيانات التعريف - الاسم، اللقب، الصورة (اختياري). معلومات الاتصال - رقم الهاتف، البريد الإلكتروني. نحن لا نجمع أي فئات خاصة من البيانات الشخصية، كما هو محدد تحت GDPR.</p>
    <h6 class="mt-5 mb-3">
      غرض معالجة البيانات الشخصية
    </h6>
    <ul>
      <h6 class="mt-4">
        <li>للمقاولين والشركات:</li>
      </h6>
      <p>1. التسجيل في تطبيق tobook.link (إنشاء الملف الشخصي).</p>
      <p>2. إعداد إحصاءات مجهولة حول استخدام تطبيق tobook.link.</p>
      <p>3. إرسال رسائل تجارية.</p>
      <p>4. وضع بيانات الشركة في مجمع الحجز عبر الإنترنت. من خلال استخدام خدمة tobook.link، فإنك توافق على وضع بيانات شركتك في مجمع الحجز عبر الإنترنت الخاص بنا والذي يملكه tobook.link. هذا يعني أننا يمكن أن نستخدم البيانات التي تقدمها للحجز عبر الإنترنت لخدماتك ولتحسين جودة خدمتنا.</p>
      <h6 class="mt-4">
        <li>للعملاء (حجز المواعيد):</li>
      </h6>
      <p>1. الحجز. يتم تخزين بياناتك الشخصية، إلى جانب تفاصيل الحجز، في حساب مزود الخدمة للعرض وتحليل تاريخ الحجز، وكذلك لأغراض تستند إلى متطلبات تنظيمية والتزامات تنشأ منها لمزود الخدمة.</p>
      <p>2. إرسال رسائل تجارية.</p>
    </ul>
    <h6 class="mt-5 mb-3">
      سجلات الدخول
    </h6>
    <p>يرجى العلم أنه كلما حدث خطأ أثناء استخدام تطبيق tobook.link الخاص بك، نحن، بمساعدة حلول الطرف الثالث، نجمع البيانات والمعلومات - سجلات الدخول - من هاتفك. قد تشمل سجلات الدخول هذه المعلومات التالية: عنوان IP للجهاز، اسم الجهاز، إصدار نظام التشغيل، تكوين التطبيق عند استخدام خدمتنا، تاريخ ووقت استخدام الخدمة، وإحصائيات أخرى.</p>
    <p>نحن نعالج ونجمع هذه المعلومات من أجل تحسين تشغيل تطبيق tobook.link، وكفاءته وتجربة المستخدم. يتم معالجة هذه البيانات على أساس مصلحتنا المشروعة في تحسين تطبيقنا وتقديم خدمة أفضل لك.</p>
    <h6 class="mt-5 mb-3">
      معالجة الدفع
    </h6>
    <p>عند الدفع مقابل الخدمات من مزودي الخدمات الخارجيين على Tobook.link، يتم معالجة الدفعات من خلال مزود بوابة الدفع لدينا، Stripe. ستقوم بتقديم معلومات بطاقة الائتمان أو الخصم مباشرةً إلى Stripe، الذي يدير خادمًا آمنًا لمعالجة تفاصيل الدفع، مشفرًا معلومات بطاقتك الائتمانية/الخصم وتفويض الدفع. Tobook.link لا يجمع أي معلومات بطاقة.</p>
    <p>المعلومات التي تقدمها إلى Stripe ليست تحت سيطرتنا وتخضع لسياسة الخصوصية الخاصة بـ Stripe <b-link href="https://stripe.com/en-cz/privacy" target="_blank">سياسة الخصوصية</b-link>.</p>
    <p>تقدم خدمات معالجة الدفع للمقاولين الفرديين والشركات على tobook.link من قبل Stripe وتخضع ل<b-link href="https://stripe.com/en-gb/legal/connect-account" target="_blank">اتفاقية حساب Stripe المتصل</b-link>التي تتضمن شروط خدمة Stripe (مجتمعة، "اتفاقية خدمات Stripe")<b-link href="https://stripe.com/en-gb/legal/ssa" target="_blank">.</b-link> بالموافقة على الاتفاقية أو الاستمرار في العمل كمقاول فردي أو شركة على tobook.link، فإنك توافق على الالتزام باتفاقية خدمات Stripe، كما قد يتم تعديلها من قبل Stripe من وقت لآخر. كشرط لتمكين tobook.link من تقديم خدمات معالجة الدفع من خلال Stripe، فإنك توافق على تقديم معلومات دقيقة وكاملة عنك وعن عملك، وتخول tobook.link لمشاركتها ومعلومات المعاملة المتعلقة باستخدامك لخدمات معالجة الدفع التي تقدمها Stripe.</p>
    <h6 class="mt-5 mb-3">
      أمان البيانات الشخصية
    </h6>
    <p>عند معالجة البيانات الشخصية، نستخدم حلول تكنولوجية متقدمة ونتعاون مع مزودي خدمات آمنين، مقيمين مخاطر الخصوصية ومستخدمين الموارد التنظيمية والمالية المتاحة لنا. نحن نتحمل المسؤولية عن البيانات الموكلة إلينا ولا نجمع أو نعالج البيانات التي ليست ضرورية لتقديم خدماتنا.</p>
    <p>موظفونا وشركاؤنا التجاريون يستخدمون البيانات فقط للأغراض المذكورة أعلاه ويخضعون لالتزامات سرية تعاقدية صارمة.</p>
    <p>سيتم تخزين البيانات الشخصية في حلول الحوسبة السحابية والخادم الآمن التي توفر معالجة البيانات في أراضي الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية. عند تغيير مزودي هذه الخدمات، نضمن دائمًا التعاون فقط مع الشركاء الموثوق بهم الذين يضمنون الامتثال لمتطلبات اللائحة. ومع ذلك، نود أن نلفت انتباهك إلى حقيقة أنه لا يوجد أسلوب تخزين إلكتروني مطلق الأمان والموثوقية والخلو من العيوب، ولا يمكننا ضمان أمانه المطلق.</p>
    <h6 class="mt-5 mb-3">
      الأسس القانونية لمعالجة البيانات الشخصية
    </h6>
    <p>نحن نعالج البيانات الشخصية لمستخدمي تطبيق tobook.link فقط على أساس الأسس القانونية التالية لمعالجة البيانات:</p>
    <ul>
      <li>موافقتك على معالجة بياناتك الشخصية لغرض واحد أو أكثر محدد.</li>
      <li>المعالجة ضرورية لإبرام اتفاق معك أو لتنفيذه، أو لاتخاذ تدابير بناءً على طلبك قبل إبرام الاتفاق.</li>
      <li>المعالجة ضرورية للوفاء بالتزاماتنا القانونية.</li>
      <li>المعالجة ضرورية لحماية مصالحك الحيوية أو مصالح الآخرين.</li>
      <li>المعالجة ضرورية لأداء مهمة تتم للمصلحة العامة.</li>
      <li>المعالجة ضرورية لمصالحنا المشروعة أو لمصالح طرف ثالث، شريطة ألا تتغلب هذه المصالح على مصالحك أو حقوقك وحرياتك الأساسية.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      فترة الاحتفاظ بالبيانات الشخصية
    </h6>
    <p>نحن نخزن البيانات الشخصية طالما:</p>
    <ul>
      <li>
        البيانات ضرورية للغرض الذي تم جمعها من أجله.
      </li>
      <li>
        يمكن لصاحب البيانات ولنا تنفيذ مصالحنا المشروعة وفقًا للإجراءات المحددة في القوانين واللوائح.
      </li>
      <li>
        هناك التزام قانوني بتخزين البيانات الشخصية.
      </li>
      <li>
        موافقة صاحب البيانات على معالجة البيانات الشخصية ذات الصلة صالحة، ما لم يكن هناك أساس قانوني آخر للمعالجة.
      </li>
    </ul>
    <p>بعد هذه الفترات، سيتم حذف بياناتك الشخصية بشكل دائم أو تجريدها من هويتها بحيث لا يمكن ربطها بك مرة أخرى.</p>
    <h6 class="mt-5 mb-3">
      نقل البيانات إلى أطراف ثالثة
    </h6>
    <p>لضمان تشغيل تطبيق tobook.link، نستخدم الخدمات التالية لأطراف ثالثة التي قد تعالج بياناتك الشخصية ("المعالجون"):</p>
    <!-- link -->
    <table-partners />
    <cite>*يرجى قراءة سياسات الخصوصية لهذه الأطراف الثالثة وكيفية معالجتها لبياناتك.</cite>
    <p class="mt-1">
      نحن لا نكشف عن بياناتك الشخصية لأطراف ثالثة أخرى، إلا:
    </p>
    <ul>
      <li>وفقًا لموافقتك الصريحة وغير القابلة للتأويل؛</li>
      <li>للأشخاص المنصوص عليهم في الأحكام التنظيمية وفقًا للإجراءات والنطاق المحدد فيها؛</li>
      <li>في الحالات المحددة في الأحكام التنظيمية لحماية المصالح المشروعة، مثل اكتشاف أو منع أو التحقيق في احتمال وقوع احتيال، انتهاكات لشروطنا أو سياساتنا، أو أنشطة غير قانونية أخرى، أو لحماية حقوقنا، ممتلكاتنا، أو سلامتنا، أو حقوق، ممتلكات، أو سلامة الآخرين.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      روابط لمواقع أخرى
    </h6>
    <p>قد يحتوي تطبيق tobook.link على روابط لمواقع ويب أو تطبيقات أخرى لا تخضع قواعد معالجة البيانات الخاصة ببيانات المستخدمين الشخصية لإدارة tobook.link. لذلك، نشجعك بشدة على قراءة سياسة السرية لهذه المواقع. نحن لا نتحكم ولا نتحمل أي مسؤولية عن المحتوى وسياسات الخصوصية لمواقع الطرف الثالث أو الخدمات.</p>
    <h6 class="mt-5 mb-3">
      خصوصية الأطفال
    </h6>
    <p>الخدمات المتاحة على تطبيق tobook.link لا تنطبق على الأشخاص دون سن 13. إذا تبين أننا قد تلقينا بيانات شخصية لطفل تحت سن 13، سنعلق خدمة tobook.link ونحذف البيانات من أنظمتنا. إذا كنت والد الطفل أو ولي أمره وعلمت أن طفلك قدم معلومات شخصية، يرجى الاتصال بنا حتى نتمكن من اتخاذ الإجراءات اللازمة.</p>
    <h6 class="mt-5 mb-3">
      الاتصالات التجارية
    </h6>
    <p>بالنظر إلى العلاقة القانونية بين tobook.link والمستخدم، ووفقًا للائحة، قد يرسل tobook.link اتصال تجاري بناءً على مصالحه المشروعة. قد يتم إرسال هذه الاتصالات بخصوص الخدمات والعروض المتعلقة بالحجوزات ونوع الخدمات التي يختارها المستخدم.</p>
    <p>سيتم إرسال اتصالات تجارية لخدمات أخرى إلى المستخدم فقط إذا وافق المستخدم على استلام هذه الاتصالات. لديك الحق في الانسحاب من استلام هذه الاتصالات في أي وقت باستخدام رابط إلغاء الاشتراك في رسائل البريد الإلكتروني أو بالاتصال بنا مباشرة.</p>
    <h6
      id="cookies"
      class="mt-5 mb-3"
    >
      "الكوكيز"
    </h6>
    <p>الكوكي هو قطعة صغيرة من البيانات المخزنة على جهاز الكمبيوتر أو الجهاز المحمول الخاص بك بواسطة المتصفح أثناء تصفح الموقع. يتيح للخادم جمع المعلومات من المتصفح الخاص بك، بحيث لا تضطر دائمًا إلى إعادة إدخال البيانات عند العودة إلى الموقع أو الانتقال من صفحة إلى أخرى. لمزيد من المعلومات حول كيفية عمل الكوكيز يرجى الرجوع إلى الموقع
      <b-link
        target="_blank"
        href="http://www.cookiecentral.com"
      >www.cookiecentral.com</b-link>.</p>
    <p>كيف نستخدم الكوكيز؟ يستخدم تطبيق tobook.link الكوكيز لتحسين جودة الخدمات، وكذلك لأداء إحصاءات مجهولة عن استخدام التطبيق وتحليل البيانات المستحصلة لأغراض التسويق. نستخدم الكوكيز الأساسية، كوكيز الجلسة والكوكيز التحليلية (كوكيز الطرف الأول والطرف الثالث (الشريك)) ل:</p>
    <ul>
      <li>ضمان أمان التطبيق وإدارته.</li>
      <li>تذكر لغة استخدام تطبيقك.</li>
      <li>تذكر ما إذا كنت قد منحت (أو لم تمنح) موافقتك على استخدام ملفات تعريف الارتباط.</li>
      <li>المساعدة في قياس فعالية حملة تسويقية.</li>
      <li>جمع معلومات حول استخدام التطبيق التي تتيح لنا قياس مدى تلبية احتياجات المستخدمين للتطبيق والقيام بأي تحسينات ضرورية.</li>
      <li>قد يتم وضع بعض ملفات تعريف الارتباط على جهاز الكمبيوتر الخاص بك من قبل أطراف ثالثة - مقدم خدمة يقوم بأداء وظائف معينة لاحتياجاتنا (على سبيل المثال، Google).</li>
    </ul>
    <p>يرجى ملاحظة أن تطبيق tobook.link يستخدم أيضًا ملفات تعريف الارتباط التي لا تتطلب موافقتك وهي:</p>
    <ul>
      <li>ملفات تعريف الارتباط للمعلومات التي تدخلها وتظل فقط خلال الجلسة</li>
      <li>ملفات تعريف الارتباط للمصادقة التي تظل فقط خلال الجلسة.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      البيانات الشخصية ونقلها
    </h6>
    <p>لا يتم استخدام المعلومات المرتبطة بملفات تعريف الارتباط لتحديد هويتك شخصياً. ومع ذلك، قد نربط هذه المعلومات بمعلومات أخرى نملكها عنك للأغراض الموضحة في هذه السياسة.</p>
    <p>قد نشارك بياناتك مع أطراف ثالثة تقدم لنا خدمات، على سبيل المثال، تحليلات تطبيق tobook.link أو خدمة العملاء. يتم تفويض هؤلاء الأشخاص لاستخدام بياناتك فقط في الحد الضروري لتقديم هذه الخدمات لنا.</p>
    <p>سنقدم بياناتك إلى أطراف ثالثة فقط كما هو موضح في سياسة الخصوصية هذه. لا نبيع بياناتك إلى أطراف ثالثة بأي شكل من الأشكال.</p>
    <h6 class="mt-5 mb-3">
      حقوقك
    </h6>
    <p>لديك الحق في طلب معلومات حول بياناتك الشخصية في أي وقت، والتحقق من دقة المعلومات المخزنة و/أو تغيير أو تحديث هذه المعلومات. يمكنك أيضًا طلب حذف بياناتك الشخصية بالكامل إذا لم تكن ضرورية لمعالجتها بعد، ما لم نكن ملزمين بالقانون بالاحتفاظ بها.</p>
    <p>سنبذل كل جهد تجاري معقول لتوفير الوصول المناسب إلى أي من بياناتك الشخصية خلال شهر واحد من استلام طلبك، ما لم تكن هناك ظروف استثنائية، وفي هذه الحالة سنطلعك عليها.</p>
    <p>لحماية خصوصيتك وأمانك، سنتخذ الخطوات المناسبة للتحقق من هويتك قبل تقديم معلومات حول البيانات الشخصية التي طلبتها.</p>
    <h6 class="mt-5 mb-3">
      الشكاوى
    </h6>
    <p>يمكن إرسال أي شكاوى وطلبات إلى: <b-link
      :to="{name: 'partners'}"
    >tobook.link</b-link></p>
    <p>إذا كنت تعتقد أننا ننتهك حقوقك القانونية، يمكنك تقديم شكوى إلى مفتش البيانات الدولي على العنوان التالي: Česká obchodní inspekce، Štěpánská 44، 110 00 Praha 1</p>
  </div>
</template>

<script>
import {
  BLink,
} from 'bootstrap-vue'
import TablePartners from '@/components/policy/TablePartners.vue'

export default {
  name: 'ArPrivacyPolicy',
  components: {
    TablePartners,
    BLink,
  },
}
</script>

<style scoped>

</style>
